import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import PDPDealCard from "../../components/APIDetails/deal-card";
import DirectPurchase from "../../components/APIDetails/direct-purchase";
import { getDealList, resetOrderPayload, responseStates } from "../../store/CoreSlice";
import styles from "../../styles/Home/Home.module.css";
import PDPStyles from "../../styles/APIDetails/[slug].module.css"
import GetInTouch from "../../components/APIDetails/GetInTouch";
import helpers from "../../utils/helpers";
import urls from "../../constants/api-endpoints"
import { useRouter } from 'next/router'
import Title from "../../components/title";
import Share from "../../components/APIDetails/Share";
import { handleAuthModal } from "../../store/AuthSlice";
import FAQsSection from "../../components/Home/FAQs";
import { MixpanelTracking } from "../../MixPanel";
import { AxiosPromise } from "../../utils/axios";
import accessToken from "../../utils/access-token";
import Requirements from '../../components/SpotBuying/Requirements';
import OrderDetails from '../../components/SpotBuying/OrderDetails';
import SuccessModal from '../../components/SuccessModal';
import Head from 'next/head';

export async function getServerSideProps(context : any) {
	const routerParam = context.params.slug
    const endPoint = helpers.getAPIEndpoint(urls.productDetails, routerParam);
	const token = context.req.cookies;
	
    const accessToken = token.accessToken;

	let data = {}
	let headers = {}

	if(accessToken) {
		headers = {
			'Authorization' : `Bearer ${accessToken}`
		}
	}

	

	const successHandler = (response : any) => {
		const fixedPriceList = response.data.fixed_price_details.map((price : any) => {
			return {...price, shrinkedCertificates : price.certificate_list.slice(0, 3)}
		});
		response.data.fixed_price_details = fixedPriceList;
		data = response.data;
	}

	const errorHandler = (error : any) => {
		console.log(error);
		if(error.response.status === 404) {
			return {
				redirect: {
					permanent: false,
					destination: "/404",
				},
			}
		}
	}

	await AxiosPromise.requestGET(
		endPoint,
		{},
		headers,
		successHandler,
		errorHandler
	)

	return {
        props : {
            data
        }
    }
}

function APIDetails({ data } : any ) {
	const dispatch: any = useDispatch();
	const router = useRouter()
	const { dealList: { list }, orderPayload } = useSelector((state: any) => state.core)
	const { user } = useSelector((state: any) => state.auth)
	const [currentURL, setCurrentURL] = useState('');
	const [showShareModal, setShowShareModal] = useState(false);
	const [currentlyActiveTab, setCurrentlyActiveTab] = useState('product_information')
	const [requirementDetails, setRequirementDetails] : any = useState({});
    const [showRequirementDetailsPopup, setShowRequirementDetailsPopup] = useState(false);
    const [orderDetailsData, setOrderDetailsData] = useState({});
    const [showOrderDetailsPopup, setShowOrderDetailsPopup] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);

	useEffect(() => {
		setCurrentURL(window.location.href);
		
		const mixPanelData = {
			productID : data.id,
			productName : data.name,
			hasFixedPrices : data.fixed_price_details.length > 0,
			hasDeals : data.deals_count > 0
		}

		MixpanelTracking.getInstance().landedToPDP(mixPanelData);
	}, []);

	useEffect(() => {
		dealList();
		router.replace(router.asPath);
	}, [user.isLoggedIn]);

	useEffect(() => {
		if(orderPayload.responseStatus === responseStates.SUCCESS) {
            setShowOrderDetailsPopup(false);
            setShowSuccessModal(true);
        }
	}, [orderPayload.responseStatus]);

	// FUNCTIONS
	const dealList = () => {
		const params = {
			page: 1,
			product : data.id
		}
		dispatch(getDealList(params))
	}

	const openRequirementsDialog = (productName : string, price : any) => {
        setRequirementDetails(() => {
            return {
                productName : productName,
                price : price
            }
        });
        setShowRequirementDetailsPopup(true);
    }

    const openOrderDetails = (productName : string, price : any, quantity : any) => {
        const decodedToken : any = helpers.decodeToken(accessToken.getAccessToken());

        setOrderDetailsData(() => {
            return {
                productName : productName,
                price : price,
                quantity : quantity,
                buyerName : decodedToken.name,
                phone : decodedToken.phone,
                email : decodedToken.email
            }
        });
        setShowOrderDetailsPopup(true);
    }

	return (
		<div className='text-theme-black lg:flex lg:justify-between items-start'>
			<Head>
				<title>
					{`${data.name} | APIdrug Platform`} 
				</title>

				<meta 
					name='description'
					content={`
						Buy ${data.name} online ip bp usp in bulk. Best price of ${data.name}, All sellers for ${data.name}, manufacturers, sellers, 
						pharmaceutical raw materials, Pharma Ingredients, api exporters, traders, marketplace for apis, sell ${data.name} online
						cas - ${data.cas_number} ${data.molecular_formula ? ` , formula - ${data.molecular_formula}` : ''} 
					`}
				/>
			</Head>

			<div className="lg:w-[56%]">
				<div className={`left-section ${PDPStyles.leftSectionAlign}`} style={{ background : '#F7F7F7', borderBottomRightRadius : 9 }}>
					<div className="flex items-start justify-between">
						<div className="flex justify-left items-start">
							{
								data.structural_formula_image &&
								<div className="image bg-white p-2 lg:p-4" style={{ borderRadius : 6 }}>
									<img
										className="object-contain w-[80px] h-[80px] lg:w-[100px] lg:h-[100px]"
										src={data.structural_formula_image.file_url}
										alt='product image'
									/>
								</div>
							}

							<div className={`lg:text-left ${data.structural_formula_image ? 'ml-4 lg:ml-6' : ''}`}>
								<h1 className="text-theme-black text-2xl lg:text-3xl font-semibold lg:my-8 lg:mt-0 lg:mb-4"> {data.name} </h1>
								<p className="text-sm lg:text-[18px]">
									CAS # <span className="font-semibold"> {data.cas_number} </span> 
								</p>
								{/* <p className="font-light mt-3 text-[12px] lg:text-normal">USP | Ph. | Eur | BP</p> */}
							</div>
						</div>

						<div onClick={() => setShowShareModal(true)} className="w-[50px] drop-shadow-sm px-2 lg:px-4 py-2 rounded-[20px] bg-white w-[30px] lg:w-[60px] h-[35px] flex items-center justify-center cursor-pointer">
							<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-5 h-5 text-theme-orange">
								<path strokeLinecap="round" strokeLinejoin="round" d="M7.217 10.907a2.25 2.25 0 100 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186l9.566-5.314m-9.566 7.5l9.566 5.314m0 0a2.25 2.25 0 103.935 2.186 2.25 2.25 0 00-3.935-2.186zm0-12.814a2.25 2.25 0 103.933-2.185 2.25 2.25 0 00-3.933 2.185z" />
							</svg>
						</div>
					</div>

					<div className="content mt-6 bg-white rounded-[4px]">
						<div className={`${PDPStyles.tabsBorder} whitespace-nowrap overflow-x-auto hide-scrollbar hide-scrollbar-2`}>
							<div className={`flex items-center justify-start pt-4 text-theme-black px-5 lg:px-8`}>
								<p  className={`text-[16px] md:text-[16px] md:text-normal pb-4 cursor-pointer font-light ${currentlyActiveTab === 'product_information' ? 'border-b-[3px] border-theme-orange font-semibold' : ''}`} 
									onClick={() => setCurrentlyActiveTab('product_information')}> 
									{data.product_information.tab_name} 
								</p>
								<p className={`text-[16px] md:text-[16px] mx-5 lg:mx-[50px] pb-4 cursor-pointer font-light ${currentlyActiveTab === 'technical_information' ? 'border-b-[3px] border-theme-orange font-semibold' : ''}`} onClick={() => setCurrentlyActiveTab('technical_information')}> 
									{data.technical_information.tab_name} 
								</p>
								<p className={`text-[16px] md:text-[16px] md:text-normal pb-4 cursor-pointer font-light ${currentlyActiveTab === 'product_description' ? 'border-b-[3px] border-theme-orange font-semibold' : ''}`} onClick={() => setCurrentlyActiveTab('product_description')} > 
									{data.product_description.tab_name} 
								</p>
							</div>
						</div>

						<div className="px-5 lg:px-8 py-8 text-[16px]">
							{
								data[currentlyActiveTab].fields.map((field : any, index : number) => (
									field.value && 
									<div className="flex my-3" key={index}>
										<p className="w-[30%] font-[500]"> {field.name} </p>
										<p className="w-[70%] font-light" dangerouslySetInnerHTML={{'__html': field.value}} /> 
									</div>
								))
							}
						</div>
					</div>
				</div>
				<div className={`hidden lg:block live-deals ${PDPStyles.leftSectionAlign}`} style={{ paddingTop: 50, paddingBottom: 60 }}>
					<h1 className='text-2xl font-semibold text-theme-blue pb-[30px]' >Frequently Asked Questions (FAQs)</h1>
					<FAQsSection />
				</div>
			</div>

			<div className={`right-section mt-10 pt-10 lg:w-[44%] mt-0 ${PDPStyles.rightSectionAlign}`} style = {{ background : 'white'}}>
				{
					list.length > 0 && 
					<div className="live-deals">
						<div className="heading flex justify-between items-center mb-7 lg:mb-5">
							<h4 className="text-xl font-semibold flex items-center">
								<div className={`${styles.dot} mb-1`}></div>
								Bulk Deals
							</h4>

							<div>
								{/* <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
									<path strokeLinecap="round" strokeLinejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
								</svg> */}
							</div>
						</div>
						<div className="deals-card">
							{
								list.map((data: any, index: number) => (
									<div key={index}>
										<PDPDealCard 
											data={data} 
											resetCard={dealList} 
											user = {user} 
											openDialog = {handleAuthModal}
										/>
									</div>
								))
							}
						</div>
					</div>
				}
				
				{
					data.fixed_price_details.length > 0 && 
					<div className={`live-deals ${list.length !== 0 && 'mt-10'}`}>
						<div className="heading flex justify-between items-center mb-7 lg:mb-5">
							<h4 className="text-xl font-semibold flex items-center">
								Spot Price
							</h4>

							<div>
								{/* <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
									<path strokeLinecap="round" strokeLinejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
								</svg> */}
							</div>
						</div>

						{
							data.fixed_price_details.map((fixedPrice : any) => (
								<div className="deals-card mb-3" key={fixedPrice.id}>						
									<DirectPurchase 
										data = {fixedPrice} 
										showPrice = {user.isLoggedIn}
										onBuyButtonClick = {() => openRequirementsDialog(data.name, fixedPrice)} 
									/>												
								</div>
							))
						}
					</div>
				}

				<div className={`live-deals ${data.fixed_price_details.length > 0 ? 'mt-10' : ''}`}>
					<div className="heading flex justify-between items-center mb-7">
						<h4 className="text-xl font-semibold flex items-center">
							Share Your Requirements
						</h4>

						<div>
							{/* <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
								<path strokeLinecap="round" strokeLinejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
							</svg> */}
						</div>
					</div>
					<div id='get-in-touch' className="deals-card">						
						<GetInTouch 
							product = {data.name}
							ID = {data.id}
						/>							
					</div>
				</div>

				<div className={`lg:hidden`} style={{ paddingTop: 50, paddingBottom: 60 }}>
					<h1 className='text-2xl font-semibold text-theme-blue pb-[30px]' >Frequently Asked Questions (FAQs)</h1>
					<FAQsSection />
				</div>
			</div>

			<Share url = {currentURL} show = {showShareModal} close = {() => setShowShareModal(false)} />

			<Requirements  
				productName = {requirementDetails.productName}
				data = {requirementDetails.price}
				show = {showRequirementDetailsPopup}
				onClose = {() => {
					setShowRequirementDetailsPopup(false);
				}}
				onRequirementsSubmit = {openOrderDetails}
			/>

			<OrderDetails 
				productName = {requirementDetails.productName}
				show = {showOrderDetailsPopup}
				onClose = {() => {
					setShowOrderDetailsPopup(false);
				}}
				data = {orderDetailsData}
			/>

			<SuccessModal 
				show = {showSuccessModal}
				image = "/OrderSuccess.svg"
				heading = "Order pending for approval"
				description = "Thank you for your purchase We will reach out to you with next steps."
				onClose = {() => {
					dispatch(resetOrderPayload());
					setShowSuccessModal(false);
				}}
			/>
		</div>
	)
}

export default APIDetails;